<div class="d-lg-block d-none">
  <fgb-banner [title]="'gallery.page.banner' | translate"></fgb-banner>
</div>

<div class="d-lg-none">
  <fgb-mobile-page-header
    pageTitle="gallery.page.banner"
    [showFooter]="false"
    [showQr]="false"
    [showBalance]="false"
    [backButtonLink]="'/'"
  ></fgb-mobile-page-header>
</div>

<!--Worksheets-->
<fgb-worksheet-list></fgb-worksheet-list>
